import { Type } from 'class-transformer';
import { IsOptional, IsString, IsUUID, ValidateNested } from 'class-validator';
import { CreateContactRequestDto } from '../contact/create-contact.request.dto';

export class OrganizationContactRequestDto {
    @IsOptional()
    @IsUUID()
    contactId?: string;

    @IsOptional()
    @ValidateNested()
    @Type(() => CreateContactRequestDto)
    contact?: CreateContactRequestDto;

    @IsOptional()
    @IsString()
    roleDescription?: string;

    @IsOptional()
    @IsString()
    context?: string;
}
